<template>
  <div>
    <div class="majorTitle">
      Account Details
    </div>
    <div class="row">
      <form @submit="updateAccount">
        <div class="form-container">
          <div class="left-column">
            <label for="first_name">First Name <span class="colorGrey">*</span></label>
            <input
              v-model="customer.first_name"
              type="text"
              name="first_name"
              required
            >

            <div class="change-email-container">
              <label for="email">Email <span class="colorGrey">*</span></label>
              <a
                class="changeEmail"
                @click="changeEmail"
              > Change Email</a>
            </div>
            <input
              id="email"
              v-model="customer.email"
              type="email"
              name="email"
              disabled
              required
            >

            <label for="phone">Phone <span class="colorGrey">*</span></label>
            <div
              style="width: 100%"
              class="backgroundColorDimmer borderGrey"
            >
              <VuePhoneNumberInput
                ref="phoneNumber"
                v-model="customer.phone"
                :no-validator-state="true"
                color="#007aff"
                valid-color="#34c263"
                error-color="#f44242"
                :default-country-code="'US'"
                :border-radius="0"
                :translations="{ phoneNumberLabel: '' }"
                :no-example="true"
              />
            </div>

            <label for="city">City <span class="colorGrey">*</span></label>
            <input
              v-model="customer.billing_city"
              type="text"
              name="city"
              required
            >

            <label for="zip">Zip <span class="colorGrey">*</span></label>
            <input
              v-model="customer.billing_zip"
              type="text"
              name="zip"
              required
            >
          </div>

          <div class="right-column">
            <label for="last_name">Last Name <span class="colorGrey">*</span></label>
            <input
              v-model="customer.last_name"
              type="text"
              name="last_name"
              required
            >

            <label for="company">Company</label>
            <input
              v-model="customer.company"
              type="text"
              name="company"
            >

            <label for="street_address">Street Address <span class="colorGrey">*</span></label>
            <input
              v-model="customer.billing_street_address"
              type="text"
              name="street_address"
              required
            >

            <label for="state">State <span class="colorGrey">*</span></label>
            <input
              v-model="customer.billing_state"
              type="text"
              name="state"
              required
            >

            <label for="country">Country <span class="colorGrey">*</span></label>
            <select
              id="country"
              v-model="customer.billing_country"
            >
              <option
                v-for="country in sortedCountries"
                :key="country.iso"
                :value="country.iso"
                :selected="customer.billing_country === country.iso || customer.billing_country === country.name"
                @index="country.iso"
              >
                {{ country.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="bottom-buttons">
          <button
            id="exitButton"
            type="button"
            class="button"
            @click="exit()"
          >
            Exit
          </button>
          <button
            id="submitButton"
            type="submit"
            class="button"
          >
            Save
          </button>
        </div>
      </form>
    </div>

    <LoadingOverlayComponent
      v-if="showLoading"
      :title="loadingTitle"
    />

    <AlertConfirmComponent
      v-if="showAlert"
      :title="alertTitle"
      :submit-text="submitText"
      :cancel-text="cancelText"
      :message="alertMessage"
      @close="() => { showAlert = false }"
      @submit="sendVerificationEmail()"
    />

    <AlertComponent
      v-if="showRegulatAlert"
      :title="regularAlertTitle"
      :message="regularAlertMessage"
      :secondary-action="null"
      @close="() => { showRegulatAlert = false }"
    />
  </div>
</template>

<script>
import LoadingOverlayComponent from '@/components/Shared/LoadingOverlayComponent.vue'
import AlertComponent from '@/components/Shared/AlertComponent.vue'
import AlertConfirmComponent from '@/components/Shared/AlertConfirmComponent.vue'
import apiMixin from '@/mixins/apiMixin.js'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import { COUNTRIES } from '@/constants'
import { isEmpty } from 'lodash'

export default {
	name: 'EditAccountComponent',
	components: {
		LoadingOverlayComponent,
		AlertConfirmComponent,
		AlertComponent,
		VuePhoneNumberInput
	},
	mixins: [apiMixin],
	data () {
		return {
			loadingTitle: 'Gathering your account details',
			loadingSubTitle: '',
			showLoading: true,
			showAlert: false,
			alertTitle: 'Verify Email',
			alertMessage: '',
			submitText: 'Send Verification Email',
			cancelText: 'Cancel',
			showRegulatAlert: false,
			regularAlertTitle: '',
			regularAlertMessage: ''
		}
	},

	computed: {
		customer: function () {
			return this.$store.getters.customer
		},
		/**
		 * Computed sort of countries
		 */
		sortedCountries () {
			return COUNTRIES.sort(function (a, b) {
				let aUp = a.name.toUpperCase()
				let bUp = b.name.toUpperCase()
				if (aUp < bUp) {
					return -1
				}
				if (aUp > bUp) {
					return 1
				}
				return 0
			})
		}
	},
	watch: {
		customer: function (customer) {
			if (customer.customer_id) {
				this.showLoading = false
			} else {
				this.showLoading = true
			}
		}
	},

	mounted () {

	},

	methods: {
		updateAccount (e) {
			e.preventDefault()

			var cmp = this
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'edit_account'
			apiPayload.postData.phone = this.customer.phone
			apiPayload.postData.street_address = this.customer.billing_street_address
			apiPayload.postData.city = this.customer.billing_city
			apiPayload.postData.state = this.customer.billing_state
			apiPayload.postData.zip = this.customer.billing_zip
			apiPayload.postData.country = this.customer.billing_country
			apiPayload.postData.customer_id = this.customer.customer_id
			apiPayload.postData.first_name = this.customer.first_name
			apiPayload.postData.last_name = this.customer.last_name
			apiPayload.postData.company = this.customer.company

			// Make sure the required fields are not empty.
			// Required fields are: first_name, last_name, email, phone, street_address, city, state, zip, country
			let requiredFields = ['first_name', 'last_name', 'phone', 'street_address', 'city', 'state', 'zip', 'country']
			let missingFields = []
			requiredFields.forEach(function (field) {
				if (isEmpty(apiPayload.postData[field].trim())) {
					missingFields.push(field)
				}
			})

			if (missingFields.length > 0) {
				this.regularAlertTitle = 'Error'
				this.regularAlertMessage = 'Please complete all required fields.'
				this.showRegulatAlert = true
				return
			}

			this.loadingTitle = 'Updating your account'
			this.showLoading = true
			cmp.$store.dispatch('apiCall', apiPayload).then(response => {
				this.showLoading = false
				if (response.data.result !== 'success') {
					this.regularAlertTitle = 'Error'
					this.regularAlertMessage = response.data.message
					this.showRegulatAlert = true
				} else {
					this.regularAlertTitle = 'Account Updated'
					this.regularAlertMessage = 'Your account has been updated.'
					this.showRegulatAlert = true
				}
			})
		},
		changeEmail () {
			this.alertMessage = 'In order to change your email, you must verify that you have access to ' + this.customer.email + '. ' +
				'If you have any questions, please contact us here: info@lelandlittle.com'

			this.showAlert = true
		},
		sendVerificationEmail () {
			this.showAlert = false

			var cmp = this
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'send_email_verification'
			apiPayload.postData.previous_email = this.customer.email
			apiPayload.postData.customer_id = this.customer.customer_id

			this.loadingTitle = 'Sending Verification Email'
			this.showLoading = true

			cmp.$store.dispatch('apiCall', apiPayload).then(response => {
				this.showLoading = false
				if (response.data.result !== 'success') {
					this.regularAlertTitle = 'Error'
					this.regularAlertMessage = response.data.message
					this.showRegulatAlert = true
				} else {
					this.regularAlertTitle = 'Email Sent!'
					this.regularAlertMessage = 'Follow the instructions in the email to update your email address.'
					this.showRegulatAlert = true
				}
			})
		},
		exit () {
			const referrer = localStorage.getItem('exit-referrer')
			if (referrer) {
				// If we have a exit-referrer, redirect to it
				window.location.replace(referrer)
				return
			}
			// Otherwise, redirect to the home page
			window.location.replace(this.getUrlHost(this.$store.getters.apiPath))
		}
	}
}
</script>

<style scoped>
.form-container {
	display: flex;
	flex-direction: row;
}

.left-column {
	flex-basis: 50%;
	margin-right: 2rem;
}

.left-column label {
	margin-top: 16px;
}

.right-column {
	flex-basis: 50%;
}

.right-column label {
	margin-top: 16px;
}

input {
	height: 44px;
}

input:last-child {
	margin-top: 0;
	margin-bottom: 0;
}

form {
	margin: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.change-email-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 100%;
	align-items: flex-end;
}

label {
	align-self: flex-start;
}

.changeEmail {
	cursor: pointer;
}

#phone {
	width: 100%;
	border: 2px solid #ccc;
	font-size: 16px;
	height: 38px;
	padding: 6px 10px;
	background-color: rgba(100, 100, 100, .05);
}

.bottom-buttons {
	margin-top: 32px;
}

#submitButton {
	background-color: #007AFF;
	color: white;
	border: 1px solid #007AFF;
	border-radius: 8px;
}

#exitButton {
	background-color: #ffffff;
	color: #333333;
	border-radius: 8px;
	margin: 0;
	margin-right: 40px;
	border: 1px solid rgba(51, 51, 51, 0.7);
}
</style>
